function initShares() {
    $('a[data-js="twitter-share"]').click(function (e) {
        var button = e.currentTarget;

        openPopup(button.href, 'twitter');

        e.preventDefault();
        return false;
    });

    $('a[data-js="facebook-share"]').click(function (e) {
        var button = e.currentTarget;

        openPopup(button.href, 'facebook');

        e.preventDefault();

        return false;
    });
}

function openPopup(url,title) {
    var w = 350;
    var h = 600;
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    var popup = window.open(url, title,

        'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
    );

    if(popup && popup.focus) {
        popup.focus();
    }
}

initShares();